import {
  ModalPageBody,
  ModalPageCopy,
  ModalPageWrapper,
} from '../../../organisms/ModalPage';
import LoseWeightJourney from '../ProfileBuilderJourneys/LoseWeightJourney';
import SmokeFreeJourney from '../ProfileBuilderJourneys/SmokeFreeJourney';
import { programmes } from '../../../../enums/programmes';
import './ProfileBuilderSelfRoot.scss';
import { Programmes } from '../../../../data/Programme';
import { useParams } from 'react-router-dom';

/**
 * Renders profileBuilder journeys for self-referrals, based on the programme they are in.
 * @returns profileBuilder journey
 */

const ProfileBuilderSelfRoot = () => {
  let { programmeSlug } = useParams();
  const currentProgId = Programmes.find(
    (x) => x.slug === programmeSlug
  )?.programmeId;

  const renderJourney = (programmeId) => {
    switch (programmeId) {
      case programmes['lose-weight'].id:
            return <LoseWeightJourney />;
        case programmes['smoke-free'].id:
            return <SmokeFreeJourney />;

      default:
        return (
          <ModalPageWrapper>
            <ModalPageBody>
              <ModalPageCopy> Something went wrong! </ModalPageCopy>
            </ModalPageBody>
          </ModalPageWrapper>
        );
    }
  };

  return <>{renderJourney(currentProgId)}</>;
};

export default ProfileBuilderSelfRoot;
